export const dashboardFields = `
chart_tracks {
    digital {
        earnings
        music_user_genre_name_contributions {
            earnings_contribution
            music_user_genre_name
            plays_contribution
        }
        percent_share
        work_title
    }
    nondigital {
        earnings
        music_user_genre_name_contributions {
            earnings_contribution
            music_user_genre_name
            plays_contribution
        }
        percent_share
        work_title
    }
}
chart_parameters {
    aggregator
    chart_name
    show
}
country_codes {
    country_code
    country_name
    earnings
}
kpis {
    cue_sheets_this_statement
    earnings_adjustments
    earnings_proxies
    earnings_settlements
    earnings_surveys
    earnings
    performances
    sources
    tracks_this_statement

}
music_user_genres {
    earnings
    music_user_genre_name
    plays
}
directed_tree {
    children {
        children {
            earnings
            entity_name
            entity_type
            plays
            children {
                earnings
                entity_name
                entity_type
                plays
            }
        }
        earnings
        entity_name
        entity_type
        plays
    }
    earnings
    entity_name
    entity_type
    plays
}
shows {
    earnings
    show_name
    plays
}
sources {
    max_earnings_per_play
    max_earnings_per_second
    min_earnings_per_play
    min_earnings_per_second
    music_user_genre_name
    plays
    source_name
}
statement_info {
    role_type
    name
    normed_statement_url
    period {
        end_date
        start_date
        unit
    }
    pro
    region
    statement_id
    user_id
}
use_codes {
    earnings
    plays
    use_code
}
`;
